import { Route, Routes } from 'react-router';
import { lazy, Suspense } from 'react';
import Home from './pages/home/Home';
import { RefreshProvider } from './utils/RefreshProvider';
import { AuthProvider } from './utils/AuthContext';
import { AdminRoute } from './pages/auth/Protection';

// Code-split everything except the landing page so public visitors don't
// download the entire admin dashboard + secondary pages up front.
const Signin = lazy(() => import('./pages/auth/Signin'));
const Signup = lazy(() => import('./pages/auth/Signup'));
const Product = lazy(() => import('./pages/product_details/Product'));
const Shop = lazy(() => import('./pages/shop/Shop'));
const Search = lazy(() => import('./pages/search/Search'));
const Layout = lazy(() => import('./admin/pages/Dashboard/Layout'));
const Settings = lazy(() => import('./settings/Settings'));
const Checkout = lazy(() => import('./pages/checkout/Checkout'));
const AccountSettings = lazy(() => import('./admin/pages/account/AccountSettings'));
const NewArrivals = lazy(() => import('./pages/new_arrivals/NewArrivals'));
const GoogleCallback = lazy(() => import('./pages/auth/GoogleCallback'));
const ForgotPassword = lazy(() => import('./pages/auth/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword'));
const ResetPswMessage = lazy(() => import('./pages/auth/ResetPswMessage'));

function App() {
  return (
    <AuthProvider>
      <RefreshProvider>
        <Suspense
          fallback={
            <div className="min-h-screen flex items-center justify-center">
              <div className="loading-spinner" />
            </div>
          }
        >
          <Routes>
            {/* Auth : */}
            <Route path='/signin' element={<Signin />} />
            <Route path='/signup' element={<Signup />} />
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/password-reset-notification" element={<ResetPswMessage />} />

            {/* Public : */}
            <Route path='/' element={<Home />} />
            <Route path='/product/:slug' element={<Product />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:gender" element={<Shop />} />
            <Route path='/search' element={<Search />} />
            <Route path="/new-arrivals" element={<NewArrivals />} />

            {/* User : */}
            <Route path="/account/*" element={<Settings />} />
            <Route path="/checkout" element={<Checkout />} />

            {/* Admin : */}
            <Route element={<AdminRoute />}>
              <Route path='/admin/settings' element={<AccountSettings />} />
              <Route path='/admin/*' element={<Layout />} />
            </Route>

          </Routes>
        </Suspense>
      </RefreshProvider>
    </AuthProvider>
  );
}
export default App;
